"use strict";
// (C) 2022-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightWidgetBuilder = exports.newInsightWidget = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
/**
 * Creates a new insightWidget with specified identifier and title and with optional modifications.
 *
 * @param insight - the insight object to create widget for.
 * @param modifications - optional modifications
 *
 * @internal
 */
function newInsightWidget(insight, modifications) {
    if (modifications === void 0) { modifications = identity_1.default; }
    var ref = sdk_model_1.insightRef(insight);
    var title = sdk_model_1.insightTitle(insight);
    var builder = new InsightWidgetBuilder(ref, title);
    return modifications(builder).build();
}
exports.newInsightWidget = newInsightWidget;
/**
 * Builder for a {@link @gooddata/sdk-model#IInsightWidgetBase} object.
 *
 * @remarks
 * The builder without any modifications returns a widget with all mandatory data. To apply
 * additional information use builder functions.
 *
 * @internal
 */
var InsightWidgetBuilder = /** @class */ (function () {
    function InsightWidgetBuilder(insightRef, title) {
        this.widget = {
            insight: sdk_model_1.uriRef(""),
            type: "insight",
            ignoreDashboardFilters: [],
            drills: [],
            title: "",
            description: "",
        };
        this.widget.insight = insightRef;
        this.widget.title = title;
    }
    InsightWidgetBuilder.prototype.withIgnoreDashboardFilters = function (ignoreDashboardFilters) {
        this.widget.ignoreDashboardFilters = ignoreDashboardFilters;
        return this;
    };
    InsightWidgetBuilder.prototype.withDrills = function (drills) {
        this.widget.drills = drills;
        return this;
    };
    InsightWidgetBuilder.prototype.withTitle = function (title) {
        this.widget.title = title;
        return this;
    };
    InsightWidgetBuilder.prototype.withDescription = function (description) {
        this.widget.description = description;
        return this;
    };
    InsightWidgetBuilder.prototype.withConfiguration = function (configuration) {
        this.widget.configuration = configuration;
        return this;
    };
    InsightWidgetBuilder.prototype.withProperties = function (properties) {
        this.widget.properties = properties;
        return this;
    };
    InsightWidgetBuilder.prototype.build = function () {
        return tslib_1.__assign({}, this.widget);
    };
    return InsightWidgetBuilder;
}());
exports.InsightWidgetBuilder = InsightWidgetBuilder;
//# sourceMappingURL=InsightWidgetBuilder.js.map